import PropTypes from 'prop-types';
import ODropDownMenu from '../../../../UI/DropDownMenu/ODropDownMenu';
import { useTranslation } from 'react-i18next';

const GridOptions = ({ children, otvoriFajlove }) => {
  const { t, i18n } = useTranslation();
  const options = [
    {
      title: t('files'),
      subtitle: t('files'),
      path: 'profil',
      id: 1,
      icon: 'fas fa-file',
      color: '#2f3a3f',
      onClick: () => otvoriFajlove(),
    },
  ];

  return (
    <ODropDownMenu align="end" position="anchor" options={options}>
      {children}
    </ODropDownMenu>
  );
};

GridOptions.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GridOptions;
